'use client';

import { useHorizontalScroll } from '@/hooks/useHorizontalScroll';
import { cn } from '@/lib/utils';

import { EdgeFade } from '@/components/atoms/EdgeFade';
import { BentoWrapper } from '@/components/bento/BentoWrapper';

import { SECTION_NAMES } from '@/integrations/trackingScripts/constants';

import { SCROLLBAR_HIDE } from '../consts';
import { AwardsProps } from '../types';
import AwardCard from './AwardCard';
import { ReviewCard } from './ReviewCard';

export default function Awards({ reviews, awards = [] }: AwardsProps) {
  const reviewsScroll = useHorizontalScroll(reviews.length);
  const awardsScroll = useHorizontalScroll(awards.length);

  return (
    <BentoWrapper
      data-tracker-section={SECTION_NAMES.BENTO_AWARDS}
      classNames={{
        root: 'pb-5',
        innerContainer: 'flex w-full flex-col gap-10',
      }}
    >
      <EdgeFade tone='dark' sides={reviewsScroll.fadeSides}>
        <div
          ref={reviewsScroll.viewportRef}
          className={cn('-my-1 overflow-x-auto py-1', SCROLLBAR_HIDE)}
          role='region'
          aria-label='Reviews'
          tabIndex={0}
        >
          <div className='flex items-stretch gap-5'>
            {reviews.map((review) => (
              <ReviewCard key={review.id} review={review} />
            ))}
          </div>
        </div>
      </EdgeFade>

      {awards.length > 0 && (
        <EdgeFade tone='dark' sides={awardsScroll.fadeSides}>
          <div
            ref={awardsScroll.viewportRef}
            className={cn('-my-1 w-full overflow-x-auto py-1', SCROLLBAR_HIDE)}
            role='region'
            aria-label='Awards'
            tabIndex={0}
          >
            <div className='flex gap-5'>
              {awards.map((award) => (
                <AwardCard key={award.id} award={award} />
              ))}
            </div>
          </div>
        </EdgeFade>
      )}
    </BentoWrapper>
  );
}
